import { getAdvancesByDay } from "@/business/advance/application/getAdvancesByDay";
import { Advance } from "@/business/advance/domain/advance";
import { ref, Ref, onMounted, computed } from "vue";
import { exportAdvancesExcel } from "@/business/advance/application/exportAdvancesExcel";
import { cancelAdvance } from "@/business/advance/application/cancelAdvance";

export function advancesUse() {
  const route: Ref<string> = ref("");
  const advances: Ref<Advance[]> = ref([]);
  const selectedDate: Ref<string> = ref("");
  const query: Ref<string> = ref("");
  const modalReceipt: Ref<boolean> = ref(false);
  const modalImages: Ref<boolean> = ref(false);
  const modalConfirmCancellation: Ref<boolean> = ref(false);
  const modalReasonCancellation: Ref<boolean> = ref(false);
  const selectedReceiptUrl: Ref<string> = ref("");
  const selectedAdvance: Ref<Advance | null> = ref(null);
  const selectedImages: Ref<string[]> = ref([]);
  const message: Ref<string> = ref("");

  async function handleDateChange(event: any) {
    const formatDate = event.target.value.replaceAll("-", "");
    advances.value = await getAdvancesByDay.execute(formatDate);
    selectedDate.value = formatDate;
    route.value = await exportAdvancesExcel.execute(formatDate);
  }

  const filteredAdvances = computed(() => {
    let result = advances.value;

    if (query.value.length > 0) {
      result = advances.value.filter((advance) =>
        advance.receiptNumber.toString().includes(query.value.toLowerCase())
      );
    }

    return result;
  });

  function openReceiptModal(advance: Advance): void {
    selectedAdvance.value = advance;
    selectedReceiptUrl.value =
      advance.state !== "ANULADO" ? advance.url : advance.cancelUrl;
    modalReceipt.value = true;
  }

  function closeReceiptModal(): void {
    modalReceipt.value = false;
    selectedAdvance.value = null;
    selectedReceiptUrl.value = "";
  }

  function openImagesModal(advance: Advance): void {
    selectedAdvance.value = advance;
    selectedImages.value = advance.vouchers || [];
    modalImages.value = true;
  }

  function closeImagesModal(): void {
    modalImages.value = false;
    selectedAdvance.value = null;
    selectedImages.value = [];
  }

  function manageConfirmCancellationModal(advance: Advance): void {
    modalConfirmCancellation.value = true;
    selectedAdvance.value = advance;
    message.value =
      "¿Está seguro de anular el recibo con número provisional " +
      advance.receiptNumber +
      "?";
  }

  function closeConfirmCancellationModal() {
    modalConfirmCancellation.value = false;
  }

  function manageReasonCancellationModal(value: boolean) {
    modalReasonCancellation.value = value;
  }

  function closeReasonCancellationModal() {
    modalReasonCancellation.value = false;
    modalConfirmCancellation.value = false;
  }

  async function nullifyAdvanceOperation(comments: string) {
    await cancelAdvance.execute(
      selectedAdvance.value?.key ?? "",
      selectedDate.value,
      selectedAdvance.value?.sellerCode ?? "",
      comments
    );
    closeReasonCancellationModal();
    advances.value = await getAdvancesByDay.execute(selectedDate.value);
  }

  const isDateSelected = computed(() => {
    return selectedDate.value.length > 0;
  });

  return {
    manageConfirmCancellationModal,
    modalConfirmCancellation,
    closeConfirmCancellationModal,
    manageReasonCancellationModal,
    modalReasonCancellation,
    closeReasonCancellationModal,
    advances,
    selectedDate,
    handleDateChange,
    filteredAdvances,
    query,
    openReceiptModal,
    modalReceipt,
    closeReceiptModal,
    selectedReceiptUrl,
    selectedImages,
    modalImages,
    closeImagesModal,
    openImagesModal,
    isDateSelected,
    route,
    nullifyAdvanceOperation,
    message,
  };
}
